import React, { PureComponent } from "react";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";

import OverallEntityAnalysisChart from "./OverallEntityAnalysisChart";
import NoData from "../NoData/NoData";
import html2canvas from "html2canvas";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";

class OverallEntityAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
        };
        this.chartEl = React.createRef();
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        if (!this.props.drilldown_charts) {
            let contextMenu = d3.select(".dashboard-charts-contextmenu");

            contextMenu.attr("data-type", "clickedMenu");
            contextMenu.style("top", `${y + 10}px`);
            contextMenu.style("left", `${x - 82}px`);
            // contextMenu.style("z-index", 99999999);
            contextMenu.style("background", `#fff`);
            contextMenu.style("color", `#1a1a1a`);
            contextMenu.html(null);
            contextMenu
                .append("li")
                .text("View Conversations")
                .on("click", () => {
                    self.handleContextMenuClick(chart);
                });
            !this.props.drilldown_charts &&
                contextMenu
                    .append("li")
                    .text("View Insights")
                    .on("click", () => {
                        // console.log('drilldown')
                        self.handleDrilldownClick(chart);
                        // this.props.showChartsDrilldown(true, "overallEntityAnalysis");
                    });
            contextMenu.style("display", "block");
        }
    };

    createNewFilter(d) {
        let newFilter = !this.props.drilldown_charts
            ? this.props.filters
                ? JSON.parse(JSON.stringify(this.props.filters))
                : {}
            : this.props.drilldown_filters.filter;
        // console.log("newFilter", newFilter);

        let gender = d.name;
        if (["male", "female"].includes(gender.toLowerCase())) {
            newFilter.entityType = "person";
            newFilter.entitySubType = gender.toLowerCase();
        }
        if (["brand", "news"].includes(gender.toLowerCase())) {
            newFilter.entityType = "non-person";
            newFilter.entitySubType = gender.toLowerCase();
        }
        if (["unknown"].includes(gender.toLowerCase())) {
            let filter_entity_type = newFilter.entityType.split(",");
            let filter_entity_subtype = newFilter.entitySubType.split(",");
            if (filter_entity_type.includes("person") && !filter_entity_type.includes("unknown")) {
                newFilter.entityType = "person";
                newFilter.entitySubType = "unknown";
            } else if (filter_entity_type.includes("unknown") && !filter_entity_type.includes("person")) {
                newFilter.entityType = "unknown";
            } else {
                newFilter.entityType = "person,unknown";
                newFilter.entitySubType = "unknown";
            }
        }
        return newFilter;
    }

    handleContextMenuClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    }

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    formatData = (data) => {
        let res = {};
        res.columns = [
            ["Male", data.male],
            ["Female", data.female],
            // ["Unknown", data.unknown],
            ["News", data.news],
            ["Brand", data.brand],
        ];
        res.total = data.male + data.female + data.unknown + data.news + data.brand;
        return res;
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let data = this.formatData(this.props.data.response);
        let csvFmt = data.columns[0].map((col, i) => data.columns.map((row) => row[i]));
        // console.log(csvFmt);
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        html2canvas(this.chartEl.current, {
            backgroundColor: options.background ? "#fff" : null,
            scrollX: 0,
            scrollY: this.props.drilldown_charts ? 50 : -window.scrollY,
        }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="This chart shows a breakdown of conversation volume based on the Entity Type." />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  ) : (
                                                      <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {(this.props.isPublic && nodata) || this.props.drilldown_charts ? null : (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />}
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart dashboard-chart-with-actions skiptranslate sentiment-overtime-chart" ref={this.chartEl}>
                        <OverallEntityAnalysisChart
                            data={this.props.data}
                            addContextMenuListener={this.addContextMenuListener}
                            // resizedCount={this.props.resizedCount}
                            showLabel={this.props.showLabel}
                            showLegend={this.props.showLegend}
                            widgetContainerRef={this.props.widgetContainerRef}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        filterOptions: state.globalReducer.filterOptions,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        drilldown_filters: state.dashboardReducer.drilldown_filters,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OverallEntityAnalysis);
